import { useEffect, useRef } from 'react';
import { useSocket } from '../../../components/contexts/SocketContext';
import { useAuth } from '../../../components/contexts/AuthContext';
import { useAccess } from '../../access/context/AccessProvider';
import { apiPost } from '../../../components/qv4/models/shared/apiClient';
import { automationNotice } from '../models/automation';
export function useAutomationNotifications(actions) {
  const { socket } = useSocket(), { authState } = useAuth(), { can } = useAccess(), latest = useRef(actions);
  latest.current = actions;
  const allowed = can('sales_pipeline.send_supplier_requests'), scope = `${authState?.id}:${authState?.token}:${authState?.session_id}`;
  useEffect(() => {
    if (!socket || !allowed || !authState?.isAuthenticated) return undefined;
    let alive = true; const seen = new Set();
    const received = event => {
      const row = event?.notification, route = automationNotice(row);
      if (!route || !row.id || seen.has(row.id)) return;
      seen.add(row.id); if (seen.size > 200) seen.delete(seen.values().next().value);
      latest.current.show({ key: `enquiry-auto:${row.id}`, message: row.title, description: row.body, duration: 10, onClick: async () => {
        if (!alive) return;
        try { await apiPost(`/notifications/${row.id}/read`); } catch { /* Routing remains available if acknowledgement fails. */ }
        if (alive) { latest.current.dismiss(`enquiry-auto:${row.id}`); latest.current.navigate(route); }
      } });
    };
    socket.on('notifications:new', received);
    return () => { alive = false; socket.off('notifications:new', received); seen.forEach(id => latest.current.dismiss(`enquiry-auto:${id}`)); };
  }, [socket, scope, authState?.isAuthenticated, allowed]);
}
